export default {
  default: {
    children: "Hello World",
    className: "",
    onClick: null,
    target: undefined,
    to: "/"
  }
}
